import withRegistroFacturaExtra from "../../hoc/Finanzas/withRegistroFacturaExtra";
import RegistroFactura from "../../view/components/Finanzas/RegistroFactura/RegistroFactura";

export default withRegistroFacturaExtra(RegistroFactura);